export default __webpack_public_path__ + "static/media/femimed_gabinet_1.4448209d.webp";